var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('picture',[_c('source',{attrs:{"media":"(max-width:640px)","srcset":_vm.mobileSrc}}),_vm._v(" "),_c('source',{attrs:{"srcset":_vm.defaultSrc}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.defaultSrc,"alt":_vm.image.alt}})])}
var staticRenderFns = []

export { render, staticRenderFns }